<template lang="pug">
div
  span.term-title {{ $langTitle(term) }}
  div.term-address(v-if="term.address && term.contact")
    span Adresa: {{term.address }}
    span.q-ml-sm Kontakt: {{ term.contact }}
  q-tooltip(v-if="term.tooltip" content-class="bg-accent")
    .text-caption {{ term.tooltip }}
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

export default @Component({

  props: {
    term: Object
  }
})
class RequestorTaxonomyViewComponent extends Vue {
}
</script>
<style lang="stylus">
.term-title
  font-weight bold

.term-address
  color gray
  padding-left 20px
  font-size smaller
  line-height 70%
</style>
